import HelpCenterViewer from './HelpCenterViewer.vue';

export default [
  {
    path: 'helpcenter',
    name: 'helpcenter_viewer',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: HelpCenterViewer,
  },
];
